import { OnsipAPIArray, onsipApiArrayToArray } from "../../apiResponse/xml-json";

export interface ApiNpaNxx {
  Num: string;
  /** rate centers */
  Nxxs: OnsipAPIArray<"Nxx", ApiNxx>;
  PostalCode?: ApiPostalCode;
}

/** rate center */
export interface ApiNxx {
  Num: string;
  /** note casing! Ratecenter is correct. RateCenter is incorrect */
  Ratecenter: string;
  Status: string;
}

export interface ApiPostalCode {
  Code: string;
  Name: string;
}

export interface NpaNxx {
  num: string;
  /** rate centers */
  nxxs: Array<Nxx>;
  postalCode?: PostalCode;
}

export interface Nxx {
  num: string;
  rateCenter: string;
  status: string;
}

export interface PostalCode {
  code: string;
  name: string;
}

export function apiNpaNxxToNpaNxx(apiNpaNxx: ApiNpaNxx): NpaNxx {
  const npaNxx: NpaNxx = {
    num: apiNpaNxx.Num,
    nxxs: onsipApiArrayToArray(apiNpaNxx.Nxxs, "Nxx").map(apiNxx => ({
      num: apiNxx.Num,
      rateCenter: apiNxx.Ratecenter,
      status: apiNxx.Status
    }))
  };
  if (apiNpaNxx.PostalCode) {
    const postalCode = { code: apiNpaNxx.PostalCode.Code, name: apiNpaNxx.PostalCode.Name };
    npaNxx.postalCode = postalCode;
  }
  return npaNxx;
}

export const TOLL_FREE_NPAS = ["800", "833", "844", "855", "866", "877", "888"];

export const UNKNOWN = ["555"];
